<template>
  <b-card style="height: 570px">
    <b-row>
      <b-col>
        <c-input
          inputType="text"
          inputId="username"
          lableText="User Name"
          v-model="access.userName"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <c-input
          inputType="password"
          inputId="pwd"
          lableText="Password"
          v-model="access.password"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <c-input
          inputType="password"
          inputId="pwd"
          lableText="Confirm Password"
          v-model="access.confirmpassword"
        />
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col md="6">
        <eb-select
          type="text"
          v-if="!isEdit"
          v-model="access.category"
          :options="categoryOptions"
          label="label"
          placeholder="Select Category"
        ></eb-select>
      </b-col>
      <b-col md="6">
        <multiselect
          v-model="access.role"
          v-if="!isEdit"
          tag-placeholder="Add this as new role"
          placeholder="Select Role"
          label="name"
          :selected="selectedRole"
          track-by="name"
          :options="roleOptions"
          :multiple="true"
          :taggable="false"
        ></multiselect>
      </b-col>
    </b-row>
    <b-row v-if="$userRole == 'Tenant'">
      <b-col md="6">
        <eb-select
          type="text"
          v-if="!isEdit"
          v-model="access.orgAccessLevel"
          :options="orgAccessOptions"
          label="label"
          placeholder="Select org Access Level"
        ></eb-select>
      </b-col>
      <b-col
        md="6"
        v-if="access.orgAccessLevel && access.orgAccessLevel.value === 'Limited'"
      >
        <multiselect
          v-model="access.orgAccessList"
          v-if="!isEdit"
          tag-placeholder="Add this as new org Access"
          placeholder="Select org Access List"
          label="userName"
          track-by="userName"
          :options="orgAccessListOptions"
          :multiple="true"
          :taggable="false"
          :open-direction="'top'"
        ></multiselect>
      </b-col>
    </b-row>

    <!-- <b-row class="mt-1">
      <b-col md="6">
        <eb-select
          type="text"
          v-model="access.geoAccessLevel"
          :options="geoAccessOptions"
          label="label"
          placeholder="Select geo Access Level"
        ></eb-select>
      </b-col>
      <b-col md="6">
        <multiselect
          v-model="access.geoAccessList"
          tag-placeholder="Add this as new geo Access"
          placeholder="Select geo Access List"
          label="label"
          track-by="label"
          :options="geoAccessListOptions"
          :multiple="true"
          :taggable="false"
        ></multiselect>
      </b-col>
    </b-row>-->

    <slot name="footer-button" :data="access"></slot>
  </b-card>
</template>
<script>
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/FormElements/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";

export default {
  name: "AcessStepper",
  props: {
    userInfo: {
      type: Object,
      required: false,
      default: () => ({
        access: {
          userName: "",
        },
      }),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedRole: "",
      access: {
        category: "",
        orgAccessLevel: "",
        geoAccessLevel: "",
        geoAccessList: null,
        role: null,
        orgAccessList: null,
        userName: "",
        password: "",
        confirmpassword: "",
      },
    };
  },
  components: {
    cInput,
    cTelInput,
    ebSelect,
  },
  computed: {
    categoryOptions() {
      return [
        { label: "ZONAL_OPERATION_HEAD", value: "ZONAL_OPERATION_HEAD" },
        { label: "HEAD_OF_STATE_UNIT", value: "HEAD_OF_STATE_UNIT" },
        { label: "HEAD_OF_SECTOR_FRANCHISEE", value: "HEAD_OF_SECTOR_FRANCHISEE" },
        { label: "TSK_ADMIN", value: "TSK_ADMIN" },
        { label: "DELIVERY_AGENT", value: "DELIVERY_AGENT" },
        { label: "CUSTOMER_SUPPORT", value: "CUSTOMER_SUPPORT" },
      ];
    },
    orgAccessOptions() {
      return [
        {
          label: "Global",
          value: "Global",
        },
        {
          label: "Limited",
          value: "Limited",
        },
      ];
    },
    geoAccessOptions() {
      return [
        {
          label: "Global",
          value: "Global",
        },
      ];
    },
    geoAccessListOptions() {
      return [
        {
          label: "Global",
          value: "Global",
        },
      ];
    },

    roleOptions() {
      let data = this.$store.getters["role/GetRoleList"];
      data = data.filter(
        (obj) =>
          obj.name !== "Admin" &&
          obj.name !== "ZONAL_OPERATION_HEAD" &&
          obj.name !== "HEAD_OF_STATE_UNIT" &&
          obj.name !== "HEAD_OF_SECTOR_FRANCHISEE" &&
          obj.name !== "TSK_ADMIN" &&
          obj.name !== "CUSTOMER_SUPPORT" &&
          obj.name !== "DELIVERY_AGENT"
      );
      return data;
    },
    orgAccessListOptions() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let tenantList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          if (obj.category === "OFFICE") {
            let arrayObj = {
              _id: obj._id,
              userName: obj.authentication.userName,
              email: obj.authentication.email,
              phone: obj.authentication.phone,
              password: "",
              ...obj,
            };
            tenantList.push(arrayObj);
          }
        });
        return tenantList;
      } else {
        return [];
      }
    },
  },
  methods: {},
  mounted() {
    setTimeout(() => {
      this.access = {
        category: "",
        userName: this.userInfo.userName || "",
      };
    }, 200);
    const partnerListData = this.$store.getters["partner/getPartnersList"];
    if (!partnerListData || !partnerListData.length)
      this.$store.dispatch("partner/fetchPartnersList").then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
        }
      });
    this.$store.dispatch("role/fetchRoles");
  },
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: #727cf5;
  color: white;
}

.sqanswer {
  margin-top: -12px !important;
}
</style>
